import { createUrqlClient as createUrqlClientCore } from '@chronosphereio/core';
import { fetch } from './fetch';

/**
 * Creates an urql client using the fetch implementation here in cloud.
 */
export function createUrqlClient() {
  return createUrqlClientCore(fetch);
}
